import React from "react";

const H2Element = ({ label, value, bgBlue, id, h1, h2, h3, h4 }) => {
  let HeadingTag = "h2";
  let headingClass = "h2-column";

  if (h1) {
    HeadingTag = "h1";
    headingClass = "h1-column";
  } else if (h2) {
    HeadingTag = "h2";
    headingClass = "h2-column";
  } else if (h3) {
    HeadingTag = "h3";
    headingClass = "h3-column";
  } else if (h4) {
    HeadingTag = "h4";
    headingClass = "h4-column";
  }

  return (
    <div>
      <label className={bgBlue ? "bgBlue_label" : ""} for={id}>
        {label}
      </label>
      <HeadingTag className={headingClass} id={id}>
        {value}
      </HeadingTag>
    </div>
  );
};

export default H2Element;
